import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
	modalSelectDropdown: {
		maxHeight: 150,
		overflowY: 'auto',
	},
}));
